import { Buffer } from 'buffer';
window.Buffer = Buffer;

(function() {
    if (typeof global === 'undefined') {
      window.global = window;
    }
})();


(function() {
  if (typeof process === 'undefined') {
    window.process = { env: {} };
  }
})();

(function() {
  if (typeof window.ethereum.setConfig === 'undefined') {
    window.ethereum.setConfig = (n) => {};
  }
})()